module.exports = __webpack_public_path__ + "img/004-user.5ee4d3d7.png";